<template>
  <div>
    <ClientOnly>
  <NavSimpleView
    v-if="config?.styleType === 'simple' && !isErpBuySite"
    :config="config"
    :isErpBuySite="isErpBuySite"
    :showNavigationList="showNavigationList"
    :actionIndex="actionIndex"
    :mallUserInfo="mallUserInfo"
    :logout="logout"
    :getLocaleText="getLocaleText"
    :getJumpType="getJumpType"
  />
  <NavDefaultView
    v-else
    :config="config"
    :isErpBuySite="isErpBuySite"
    v-model:searchKeyword="searchInputVal"
    v-model:searchType="searchTypeVal"
    :mallUserInfo="mallUserInfo"
    :showNavigationList="showNavigationList"
    :actionIndex="actionIndex"
    :getLocaleText="getLocaleText"
    :getJumpType="getJumpType"
    :onKeywordSearch="onKeywordSearch"
    :openImgSearch="openImgSearch"
    :logout="logout"
  />
  </ClientOnly>
  </div>
</template>

<script setup>
import { ref, onMounted,onBeforeMount, computed, watch } from "vue";
import { getTabBarConfigList } from "@/api/index.js";
import { extract1688OfferId, extractTaobaoItemId, extractWeidianItemId } from "@/utils/index.js";
import useLocate from "~/components/render/uses/useLocate.js";
import { useMainStore } from "~/composables/store";
import { useNuxtApp } from "#app";
const { $isErpBuySite } = useNuxtApp()
import { useRoute } from "vue-router";
import { get } from "lodash-es";
import NavDefaultView from "./NavDefaultView.vue";
import NavSimpleView from "./NavSimpleView.vue";
const store = useMainStore();
const isErpBuySite = computed(() => Boolean($isErpBuySite?.value));

// 引入自定义 mixins (合并到 composable 中)
const { getLocaleText } = useLocate();

function logout() {
  store.logout();
}
const props = defineProps({
 
  parentKeys: {
    type: Array,
    default: () => []
  },
  disabled: {
    type: Boolean,
    default: true
  },
  config: {
    type: Object,
    default: () => ({})
  }
});

const actionIndex = ref(0);
const activeIndex = ref(null);
const navigationList = ref([]);
const searchInputVal = ref("");
const searchTypeVal = ref("1");
const edit = computed(() => !props.disabled);
const mallUserInfo = computed(() => get(store, "$state.mallUserInfo") || {});

navigationList.value = Array.isArray(get(store, "$state.navigationList"))
  ? get(store, "$state.navigationList")
  : [];

const showNavigationList = computed(() =>{
  if(props.config && props.config.navigationList && props.config.navigationList.length){
    return props.config.navigationList;
  }else{
    return get(store, "$state.navigationList")||[];
  }

});

const isSimple = computed(() => props.config?.styleType === "simple" && !isErpBuySite.value);

const route = useRoute();

function syncSearchTypeByRoute() {
  const platform = String(route.query?.platform || "").trim();
  if (platform === "taobao" || String(route.path || "").startsWith("/tb")) {
    searchTypeVal.value = "2";
    return;
  }
  searchTypeVal.value = "1";
}

const getPcNavigatorData = async () => {
  const param = {
    pageNo: 0,
    pageSize: 9999,
    showType: "1",
    status: "1"
  };

  if ((!Array.isArray(navigationList.value) || !navigationList.value.length) && process.client) {
    try{
      const res = await getTabBarConfigList(param);
      if (res.data && res.data.dataList) {
        const list = res.data.dataList.sort((a, b) => {
          const aSort = a.sortNo ?? 0;
          const bSort = b.sortNo ?? 0;
          return aSort - bSort;
        });
        navigationList.value = list;
      }
    }catch(e){
      console.log("getTabBarConfigList",e)
    }
  }

  const currentPageAddress =
    typeof window !== "undefined"
      ? window.location.href.replace(window.location.origin, "")
      : "";
  if (!Array.isArray(navigationList.value) || !navigationList.value.length) return;
  for (let index = 0; index < navigationList.value.length; index++) {
    const item = navigationList.value[index];
    const linkUrl = item?.linkUrl;
    if (typeof currentPageAddress === "string" && currentPageAddress.indexOf(linkUrl) !== -1) {
      actionIndex.value = index;
      break;
    }
  }
};

function openImgSearch() {
  navigateTo({
    path: "/product/search",
    query: {
      searchType: "img",
      imgSrc: "",
      platform: searchTypeVal.value === "2" ? "taobao" : "1688",
      key: Date.now(),
    }
  });
}

function onKeywordSearch() {
  const keyword = String(searchInputVal.value || "").trim();
  if (!keyword) return;

  const offerId = extract1688OfferId(keyword);
  if (offerId) {
    navigateTo({
      path: "/product",
      query: {
        detailId: offerId,
        key: Date.now(),
      }
    });
    return;
  }

  const taobaoItemId = extractTaobaoItemId(keyword);
  if (taobaoItemId) {
    navigateTo(`/tb/goods/${encodeURIComponent(taobaoItemId)}`);
    return;
  }

  const weidianItemId = extractWeidianItemId(keyword);
  if (weidianItemId) {
    navigateTo(`/wd/goods/${encodeURIComponent(weidianItemId)}`);
    return;
  }

  navigateTo({
    path: "/product/search",
    query: {
      keyword,
      platform: searchTypeVal.value === "2" ? "taobao" : "1688",
      key: Date.now(),
    }
  });
}
watch(
  () => props.config.itemConfigs,
  async value => {
    if (value) {
      await getPcNavigatorData();
    }
  },
  { deep: true }
);
watch(
  () => route,
  async value => {
    if (value) {
      syncSearchTypeByRoute();
      await getPcNavigatorData();
    }
  },
  { deep: true }
);

onMounted(() => {
  syncSearchTypeByRoute();
  if (typeof window !== "undefined") {
    if (!window.pageTabs) {
      window.pageTabs = {};
    }
    window.pageTabs[props.config.id] = {
      setTab,
      getTab
    };
  }

  getPcNavigatorData();
});

onBeforeMount(()=>{
  syncSearchTypeByRoute();
  if(process.client){
    store.getCurrencyData();
  }
  
});

const getTab = () => activeIndex.value;
const setTab = i => {
  if (props.config.navigationItemConfigs[i]) {
    activeIndex.value = props.config.navigationItemConfigs[i].config.text + i;
  }
};
const getJumpType = (item, isNuxtLink) => {
  let jumpWay = "_Self";
  switch (item.linkType) {
    case 0:
      jumpWay = "_Blank";
      break;
    case 10:
      jumpWay = "_Self";
      break;
  }
  if (isNuxtLink && jumpWay == "_Self") {
    return undefined;
  }
  return jumpWay;
};

const navigationClickFn = (item, index) => {
  if (!item) return;
  actionIndex.value = index;
  let jumpWay = getJumpType(item);

  if (item.linkUrl) {
    window.open(item.linkUrl, jumpWay);
  }
};

const handleSelect = value => {
  // handle select logic
};
</script>
